import { IonRouterOutlet } from '@ionic/react';
import React from 'react';

import PrivateRoute from '@components/PrivateRoute';
import RoutePath from '@custom-types/RoutePath';
import { generateRoute } from '@services/navigation-service';

import Details from './Details';

export default () => (
  <IonRouterOutlet>
    <PrivateRoute exact path={generateRoute(RoutePath.PersonDetails)}>
      <Details />
    </PrivateRoute>
  </IonRouterOutlet>
);
